import { useContext } from 'react';
import { SelectedFiltersContext } from '../../context/SelectedFiltersContext';

export const useSelectedFiltersContext = () => {
  const context = useContext(SelectedFiltersContext);

  if (context === undefined) {
    throw new Error(
      'useSelectedFiltersContext must be used within a SelectedFiltersContextProvider'
    );
  }

  return context;
};
